import React, { useState, useEffect } from 'react';
import ResponseMsg from '../general/ResponseMsg';
import MyMedicine from '../assets/my-medicine.gif';
import { useNavigate } from 'react-router-dom';

const Store = ({ userData }) => {
  const navigate = useNavigate();
  const [response, setResponse] = useState('');
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [showUpdate, setShowUpdate] = useState(false);
  const [formData, setFormData] = useState({
    updatedStock: '',
  });

  useEffect(() => {

    fetchProducts();
  }, [userData.id]);


      const fetchProducts = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-mymedicine/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          setProducts(data);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };


  // Search among products
  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Update medicine stock
  const showStockDialog = (product) => {
    setSelectedProduct(product);
    setShowUpdate(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdateStock = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    console.log(selectedProduct);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/update-stock/${userData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          stock: formData.updatedStock,
          product_id: selectedProduct.product_id,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setResponse(result.message);
        setShowUpdate(false);
        setFormData({updatedStock: ''});
        setTimeout(() => {
          setResponse('');
        }, 2000);
    fetchProducts();

        // window.location.reload();
        // setProducts((prevProducts) =>
        //   prevProducts.map((product) =>
        //     product.id === selectedProduct.product_id ? { ...product, stock: formData.updatedStock } : product
        //   )
        // );
      } else {
        setResponse(result.message || 'Something went wrong');
        setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error('Error updating stock:', error);
    }
  };

  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-4'>

          <div className='d-lg-flex d-md-flex d-block justify-content-between'>
            <div className='d-flex'>
              <p className='sec-heading'>My Medicine</p>
              <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Store</span>
            </div>

            <div className="text-start mb-4">
              <input
                type="text"
                className="form-input w-auto rounded border-0"
                placeholder="🎯 Search products..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className='row bg-white rounded-4 px-lg-2 py-3 animate__animated animate__fadeIn justify-content-start'>
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <div key={product.id} className='col-lg-2 col-md-4 col-sm-6 col-6 my-2 px-2'>
                  <div className='featured-area h-100 align-content-center'>
                    <div className='featured-btn-area d-block bg-transparent'>
                      <p className='text-muted fw-semibold bg-light px-2 rounded'>
                        {product.stock == '0' ? 'Out of Stock' : `${product.stock} in Stock`}
                      </p>
                    </div>

                    <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid' alt={product.name || 'Product'} />
                    <p className='featured-category'>{product.unit || 'Unit'}</p>
                    <p className='featured-name cursor-pointer' onClick={() => navigate(`/product-details/${product.name}`, { state: { product } })}>{product.name}</p>
                    <p className='featured-price d-flex justify-content-center mt-0'>₹ {product.sell_price}</p>
                    <button className='login-btn2 py-1' onClick={() => showStockDialog(product)}>+ Stock</button>
                  </div>
                </div>
              ))
            ) : (
              <div className='text-center'>
                <img src={MyMedicine} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                <p className='fw-bold'>No Medicines Added to Store.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {showUpdate && (
        <section className='delete-dialog px-3' onClick={() => setShowUpdate(false)}>
          <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
            <p className='featured-category my-4'>Stock for {selectedProduct.name}</p>

            {/* Form for updating stock */}
            <form className="row g-3" onSubmit={handleUpdateStock}>
              <div className="col-12">
                <input
                  type="number"
                  className="form-input"
                  id="inputStock"
                  name="updatedStock"
                  placeholder="Enter Stock Qty"
                  value={formData.updatedStock}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-12 my-4">
                <button
                  className="btn text-light px-3 py-1 bg-danger"
                  onClick={() => setShowUpdate(false)}
                >
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button type="submit" className="btn text-light px-3 py-1 bg-success">
                  Update
                </button>
              </div>
            </form>
          </div>
        </section>
      )}

      {response && <ResponseMsg message={response} />}
    </>
  );
};

export default Store;
